import { Loader2 } from "lucide-react";
import {
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogHeader,
	AlertDialogMedia,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function NpsLoadingAlert() {
	return (
		<AlertDialogContent>
			<AlertDialogHeader>
				<AlertDialogMedia>
					<Loader2 className="animate-spin text-primary" />
				</AlertDialogMedia>
				<AlertDialogTitle>Enviando sua avaliação...</AlertDialogTitle>
				<AlertDialogDescription>
					Estamos processando seu feedback. Isso pode levar alguns segundos.
				</AlertDialogDescription>
			</AlertDialogHeader>
		</AlertDialogContent>
	);
}
